import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ZefFormBase } from '@zerops/zef/forms';
import { UserInfoFieldsTranslations } from '@zerops/zui/user-info-fields';
import { AccountFormState } from './account-form.form';

@Component({
  selector: 'z-account-form',
  templateUrl: './account-form.component.html',
  styleUrls: [ './account-form.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountFormComponent extends ZefFormBase<AccountFormState> {
  @Input()
  userInfoFieldsTranslations: UserInfoFieldsTranslations;
}
